<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items()"
      :pagination="pagination()"
      :loading="isLoading()"
      class="elevation-1"
      @update:pagination="setPagination"
    >
      <template #items="{ item, index }">
        <td class="text-xs-right">
          {{ (pagination().page - 1) * pagination().rowsPerPage + index + 1 }}
        </td>
        <td>{{ [item.first_name, item.last_name].join(' ').trim() || '-' }}</td>
        <td>{{ item.channel || '-' }}</td>
        <td>{{ item.pdpa_consent ? $t('consent') : $t('dissent') }}</td>
        <td v-for="key in filterKeys" :key="key">{{ item[key] || '-' }}</td>
        <td>{{ item.feedback || '-' }}</td>
        <td>{{ item.created_at | DateFormat('DD/MM/YY HH:mm') }}</td>
        <td>
          <v-btn flat icon color="primary" right @click="view(item)">
            <v-icon>visibility</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <SurveyViewDialog v-model="isViewDialogVisible" />
  </div>
</template>

<script>
import SurveyViewDialog from './SurveyViewDialog.vue'

export default {
  components: { SurveyViewDialog },
  inject: ['isLoading', 'items', 'pagination', 'setPagination', 'survey', 'setViewedItem'],
  data() {
    return {
      isViewDialogVisible: false
    }
  },
  computed: {
    filterKeys() {
      return Object.keys(this.survey().filter_json)
    },
    headers() {
      return [
        { text: this.$t('no.'), sortable: false, align: 'right' },
        { text: this.$t('name'), sortable: false },
        { text: this.$t('channel'), sortable: false },
        { text: 'PDPA', sortable: false },
        ...this.filterKeys.map((key) => ({ text: this.$t(key), sortable: false })),
        { text: this.$t('suggestion'), sortable: false },
        { text: this.$t('Created Date'), sortable: false },
        { text: this.$t('Action'), sortable: false }
      ]
    }
  },
  methods: {
    async view(item) {
      this.setViewedItem(null)
      await this.$nextTick()
      this.setViewedItem(item)
      this.isViewDialogVisible = true
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/Survey/SurveyTable.vue